import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/lib/Col';
import { change as changeForm } from 'redux-form';
import cns from 'classnames';
import { connect } from 'react-redux';

import { withTracker, hitTypes } from 'helpers/tracking';
import { PriceInputRangeControl } from 'components/forms/filters/Price';
import { RangeSliderField } from 'components/forms/RangeSlider';
import { InputBoxesField } from 'components/forms/InputBoxes';
import {
  MONTHLY_PRICE_RANGE_NAME,
  PRICE_RANGE_NAME,
  MIN_PRICE_VALUE,
  MAX_PRICE_VALUE,
  MIN_MONTHLY_PRICE,
  MAX_MONTHLY_PRICE,
  PRICE_TYPE_NAME,
} from 'components/searchAds/constants';
import {
  BUY_PRICE,
  MONTHLY_PRICE,
  options as priceTypeOptions,
} from 'helpers/fieldOptions/ad/priceType';
import mapStateToProps from './mapStateToProps';

import cn from './styles.local.less';

const COL_7 = 7;
const COL_5 = 5;

class PriceItem extends PureComponent {
  static propTypes = {
    priceType: PropTypes.string.isRequired,
    tracker: PropTypes.object.isRequired,
    onChanged: PropTypes.func.isRequired,
    showMonthlyPrice: PropTypes.bool,
  };

  getPriceOptions = () =>
    this.props.showMonthlyPrice
      ? priceTypeOptions
      : priceTypeOptions.filter(
          (priceType) => priceType.value !== MONTHLY_PRICE,
        );

  handlePriceChange = async () => {
    const { formName, changeForm, onChanged } = this.props;

    await changeForm(formName, MONTHLY_PRICE_RANGE_NAME, null);
    onChanged();
  };

  handleMonthlyPriceChange = async () => {
    const { formName, changeForm, onChanged } = this.props;

    await changeForm(formName, PRICE_RANGE_NAME, null);
    onChanged();
  };

  handleSliderChange = (name, value) => {
    const { tracker } = this.props;

    tracker.track(hitTypes.PRICE_RANGE_SLIDER_CHANGE, {
      label:
        name === PRICE_RANGE_NAME ? 'PriceRangeSlider' : 'MonthlyRangeSlider',
      value,
    });
  };

  handleInputControlChange = (name, value) => {
    const { tracker } = this.props;

    tracker.track(hitTypes.PRICE_INPUT_RANGE_CHANGE, {
      label:
        name === PRICE_RANGE_NAME
          ? 'PriceRangeInputBox'
          : 'MonthlyRangeInputBox',
      value,
    });
  };

  renderPriceTypeSelectorCol = ({ colProps, input }) => {
    const isMonthlyPrice = input.value === MONTHLY_PRICE;
    const props = {
      ...colProps,
      xs: isMonthlyPrice ? COL_7 : COL_5,
      className: cns({
        [cn.monthlyPriceCol]: isMonthlyPrice,
        [cn.priceCol]: !isMonthlyPrice,
      }),
    };

    return <Col {...props} />;
  };

  render() {
    const { priceType } = this.props;

    return (
      <div className={cn.root}>
        <InputBoxesField
          name={PRICE_TYPE_NAME}
          options={this.getPriceOptions()}
          type="radio"
          renderCol={this.renderPriceTypeSelectorCol}
        />

        {priceType === BUY_PRICE ? (
          <div className={cn.priceTypeBody}>
            <RangeSliderField
              name={PRICE_RANGE_NAME}
              onChanged={this.handlePriceChange}
              onInputControlChange={(value) =>
                this.handleInputControlChange(PRICE_RANGE_NAME, value)
              }
              onSliderChange={(value) =>
                this.handleSliderChange(PRICE_RANGE_NAME, value)
              }
              InputControl={PriceInputRangeControl}
              RangeLabel={() => null}
              minValue={MIN_PRICE_VALUE}
              maxValue={MAX_PRICE_VALUE}
              emptyValue={{ min: MIN_PRICE_VALUE, max: MAX_PRICE_VALUE }}
              step={500}
              className={cn.rangeSliderControl}
              isRangeMode
              showLabelBefore
            />
          </div>
        ) : (
          <div className={cn.priceTypeBody}>
            <RangeSliderField
              name={MONTHLY_PRICE_RANGE_NAME}
              onChanged={this.handleMonthlyPriceChange}
              onInputControlChange={(value) =>
                this.handleInputControlChange(MONTHLY_PRICE_RANGE_NAME, value)
              }
              onSliderChange={(value) =>
                this.handleSliderChange(MONTHLY_PRICE_RANGE_NAME, value)
              }
              InputControl={PriceInputRangeControl}
              RangeLabel={() => null}
              minValue={MIN_MONTHLY_PRICE}
              maxValue={MAX_MONTHLY_PRICE}
              emptyValue={{ min: MIN_MONTHLY_PRICE, max: MAX_MONTHLY_PRICE }}
              step={10}
              className={cn.rangeSliderControl}
              isRangeMode
              showLabelBefore
            />
          </div>
        )}
      </div>
    );
  }
}

export default withTracker(connect(mapStateToProps, { changeForm })(PriceItem));
